import { string, bool, number } from 'prop-types'
import { PureComponent } from 'react'
import Measure from 'react-measure'
import { kuiperClassNames } from '../../utils'
import TextArea from '../TextArea'
import './styles.scss'

class FluidInput extends PureComponent {
  static propTypes = {
    disabled: bool,
    forceUpdate: bool,
    placeholder: string,
    placeholderMinWidth: number,
    value: string,
  }

  static defaultProps = {
    placeholder: 'Add text...',
    placeholderMinWidth: 70,
    value: '',
  }

  constructor(props) {
    super(props)

    this.state = { width: this.props.placeholderMinWidth }
  }

  measureComponent(contentRect) {
    const width = contentRect.bounds.width + 5
    if (width !== this.state.width) {
      this.setState({ width })
    }
  }

  get formatText() {
    // convert space at end of input to nbsp to ensure width is measured properly
    if (this.props.value.endsWith(' ')) {
      return <span>{this.props.value.trim()}&nbsp;</span>
    }

    return this.props.value || this.props.placeholder
  }

  render() {
    const minWidth = this.props.value ? 0 : this.props.placeholderMinWidth
    return (
      <div className={kuiperClassNames('fluid-input')}>
        <TextArea
          {...this.props}
          style={{ width: this.state.width, minWidth }}
        />
        {Boolean(!this.props.disabled || this.props.value.length > 0) && (
          <Measure
            bounds={true}
            onResize={(contentRect) => this.measureComponent(contentRect)}
          >
            {({ measureRef }) => (
              <div
                className={kuiperClassNames('fluid-input-value-sizer')}
                style={{ minWidth }}
                ref={measureRef}
              >
                {this.formatText}
              </div>
            )}
          </Measure>
        )}
      </div>
    )
  }
}

export default FluidInput
